// Copyright © 2021 Move Closer
import { computed, ref } from '@vue/composition-api';
import { DropdownAlignmentMap, DropdownPositionMap } from './Dropdown.contracts';
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const dropdownProps = {
    align: {
        type: String,
        required: false,
        default: () => DropdownAlignmentMap.Left
    },
    icon: {
        type: String,
        required: false,
        default: null
    },
    items: {
        type: Array,
        required: false,
        default: () => []
    },
    label: {
        type: String,
        required: false,
        default: ''
    },
    openOnMount: {
        type: Boolean,
        required: false,
        default: false
    },
    position: {
        type: String,
        required: false,
        default: () => DropdownPositionMap.Down
    }
};
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function useDropdown(props, ctx) {
    const isOpen = ref(props.openOnMount || false);
    const hasCustomTrigger = computed(() => props.trigger !== null);
    const close = () => { isOpen.value = false; };
    const open = () => { isOpen.value = true; };
    const toggle = () => { isOpen.value ? close() : open(); };
    return { close, hasCustomTrigger, isOpen, open, toggle };
}
